import React from "react";

import Paragraph from '../../Paragraph/Paragraph';
import styles from "./Vision.module.scss";

export default function Vision() {
  return (
    <div className={styles.container}>
      <Paragraph
        title="Với kinh nghiệm và tầm nhìn của bạn trong lĩnh vực ngoại hối, bạn có thể đưa ra lời khuyên cho tất cả các nhà giao dịch hoặc những người đang có ý định tham gia thị trường ngoại hối không?"
        content={[
          "Nếu bạn mạo hiểm với số tiền bạn không thể để mất, bạn sẽ thất bại. Các quỹ cho phép bạn giao dịch mà không tăng đáng kể rủi ro cá nhân. Nếu bạn thua lỗ, bạn chỉ mất phí tham gia; đó là một khoản chi cố định và có kiểm soát mà bạn đã chi tiêu, không phải một khoản ký gửi bạn có thể nhận lại. Thay đổi tư duy này có thể giúp các nhà giao dịch như bạn thành công.",
          "Nếu bạn mới tham gia giao dịch forex, lời khuyên của tôi là bắt đầu bằng các nền tảng giao dịch hiện đại sẽ hỗ trợ bạn trong nhiều năm tới. Đừng bắt đầu với các nền tảng lỗi thời, vì chúng sớm muộn cũng sẽ trở nên lỗi thời."
        ]}
        contentStyle={{ maxWidth: "1081px" }}
      />
    </div>
  );
}
